export default __webpack_public_path__ + "static/media/avatar_2.b370b114.svg";